module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/categories/add/add.html
// module id = 381
// module chunks = 0